import { NgModule } from '@angular/core';

import { BrowserLazyViewDirective } from './directives/browser-lazy-view.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { CreateFilterDirective } from './directives/create-filter.directive';
import { FocusOutsideDirective } from './directives/focus-outside.directive';
import { FormSubmitDirective } from './directives/form-submit.directive';
import { IdentityProviderCapabilityDirective } from './directives/identity-provider-capability.directive';
import { ImageZoomMagnifierDirective } from './directives/image-zoom-magnifier';
import { IntersectionObserverDirective } from './directives/intersection-observer.directive';
import { LazyLoadingContentDirective } from './directives/lazy-loading-content.directive';
import { PaypalErrorDirective } from './directives/paypal-error.directive';
import { ProductContextAccessDirective } from './directives/product-context-access.directive';
import { ProductContextDirective } from './directives/product-context.directive';
import { ScrollDirective } from './directives/scroll.directive';
import { ServerHtmlDirective } from './directives/server-html.directive';
import { SortableDirective } from './directives/sortable.directive';
import { CategoryContextDirective } from './directives/category-context.directive';

@NgModule({
  imports: [
    BrowserLazyViewDirective,
    ClickOutsideDirective,
    CreateFilterDirective,
    FocusOutsideDirective,
    FormSubmitDirective,
    IdentityProviderCapabilityDirective,
    ImageZoomMagnifierDirective,
    IntersectionObserverDirective,
    LazyLoadingContentDirective,
    PaypalErrorDirective,
    ProductContextAccessDirective,
    ProductContextDirective,
    ScrollDirective,
    ServerHtmlDirective,
    SortableDirective,
    CategoryContextDirective,
  ],
  exports: [
    BrowserLazyViewDirective,
    ClickOutsideDirective,
    CreateFilterDirective,
    FocusOutsideDirective,
    FormSubmitDirective,
    IdentityProviderCapabilityDirective,
    ImageZoomMagnifierDirective,
    IntersectionObserverDirective,
    LazyLoadingContentDirective,
    PaypalErrorDirective,
    ProductContextAccessDirective,
    ProductContextDirective,
    CategoryContextDirective,
    ScrollDirective,
    ServerHtmlDirective,
    SortableDirective,
  ],
})
export class DirectivesModule {}
